{
	"ariaCancelPublish": "Cancel Publish To Pixieset",
	"ariaConfirmPublish": "Confirm Publish To Pixieset",
	"ariaSelectSet": "Select Pixieset Set",
	"cancelPublishMessage": "The remaining photos awaiting to be published will be canceled.",
	"cancelPublishPrimary": "Cancel Publish",
	"cancelPublishTitle": "Are you sure?",
	"cancellingPublish": "Cancelling publish and restoring the current photo...",
	"changesToPublish": "Changes to Publish",
	"deleteAndPublish": "Delete and Publish",
	"deleteConfirmMessage": "Publishing to this collection will permanently delete {{count}} photo(s) from your Client Gallery. This cannot be undone.",
	"deleteConfirmTitle": "Are you sure?",
	"doNotLeaveApp": "Do not leave the app, doing so could corrupt the exported photos and disrupt publishing.",
	"estimatedPublishSize": "Estimated Publish Size",
	"exportingAndPublishing": "Exporting and publishing photos...",
	"failedToLoadSets": "Failed to load sets",
	"failedToPublishPleaseTry": "Failed to publish. Please try again later.",
	"hours_one": "{{count}} hour",
	"hours_other": "{{count}} hours",
	"insufficientStorage": "You do not have enough storage to publish. Please free up space on Client Gallery and try again.",
	"loadingSets": "Loading sets...",
	"minutes_one": "{{count}} minute",
	"minutes_other": "{{count}} minutes",
	"noChangesDetected": "No changes detected",
	"noSetsAvailable": "No sets available",
	"photosWillBeAdded_one": "{{count}} photo will be added",
	"photosWillBeAdded_other": "{{count}} photos will be added",
	"photosWillBeDeleted_one": "{{count}} photo will be deleted",
	"photosWillBeDeleted_other": "{{count}} photos will be deleted",
	"photosWillBeUpdated_one": "{{count}} photo will be updated",
	"photosWillBeUpdated_other": "{{count}} photos will be updated",
	"preparingUpload": "Preparing to upload...",
	"publish": "Publish",
	"publishSizeError": "One or more photos are too small to export with the current custom dimensions. Increase the dimensions to continue.",
	"publishSizeError2": "One or more photos exceed the 12,000 × 12,000 px custom export limit. Reduce the custom dimensions to continue.",
	"seconds_one": "{{count}} second",
	"seconds_other": "{{count}} seconds",
	"selectCollection": "Select collection",
	"selectedCollection": "Selected Collection",
	"selectedSet": "Selected Set",
	"title": "Publish to Pixieset",
	"uploadingProgress": "Uploading {{uploads}}/{{totalToUpload}}, at {{bitrate}}",
	"uploadingProgressTime": "Uploading {{uploads}}/{{totalToUpload}}, at {{bitrate}}, time remaining: {{timeRemaining}}"
}
